import { PagesEnum } from "./types";

export const DashboardPages = {
  path: PagesEnum.Dashboard,
  label: "Dashboard",
  component: null,
};
